import { storageKeys } from 'config/settings.json';
import StorageHandler from 'config/StorageHandler';

const DEFAULT_LANGUAGE = {
  country: 'English',
  code: 'en',
  langFile: 'en',
};
const PRESERVED_STORAGE_KEYS = new Set([storageKeys.appId.name]);
const EXTRA_APP_STORAGE_KEYS = ['visitedLinks'];
const DYNAMIC_APP_STORAGE_KEY_PREFIXES = ['hasSeenWelcomeVideo_'];

function getStorageKeyName(key) {
  return key.name || key;
}

function normalizeAppId(value) {
  return String(value ?? '').trim();
}

function removeDynamicAppStorageKeys() {
  DYNAMIC_APP_STORAGE_KEY_PREFIXES.forEach((prefix) => {
    Object.keys(window.localStorage)
      .filter((key) => key.startsWith(prefix))
      .forEach((key) => {
        window.localStorage.removeItem(key);
      });
  });
}

function removeAppStorageKeys() {
  Object.values(storageKeys).forEach((key) => {
    const keyName = getStorageKeyName(key);

    if (!PRESERVED_STORAGE_KEYS.has(keyName)) {
      StorageHandler.remove(key);
    }
  });

  EXTRA_APP_STORAGE_KEYS.forEach((key) => {
    StorageHandler.remove(key);
  });

  removeDynamicAppStorageKeys();
}

export async function ensureCurrentAppStorage() {
  const currentAppId = normalizeAppId(import.meta.env.VITE_APP_ID);

  if (!currentAppId) {
    return false;
  }

  const storedAppId = normalizeAppId(await StorageHandler.load(storageKeys.appId));
  const storedAppInfo = await StorageHandler.load(storageKeys.appInfo);
  const storedAppInfoAppId = normalizeAppId(storedAppInfo?.appId);

  const hasStaleAppId = storedAppId !== '' && storedAppId !== currentAppId;
  const hasStaleAppInfo = storedAppInfoAppId !== '' && storedAppInfoAppId !== currentAppId;

  if (hasStaleAppId || hasStaleAppInfo) {
    removeAppStorageKeys();
    StorageHandler.save(storageKeys.lang, DEFAULT_LANGUAGE);
  }

  StorageHandler.save(storageKeys.appId, currentAppId);

  return hasStaleAppId || hasStaleAppInfo;
}
